export default __webpack_public_path__ + "static/media/DiceSharing.c64f4786.mp4";